export function updateInternalMessage(message) {
  return {
    type: 'UPDATE_INTERNAL_MESSAGE',
    payload: message,
  };
}
